<template>
  <div>
    <div class="inline-block-vertical-align-middle">
      <div class="inline-block-vertical-align-middle"><img :src="publicUrl + imageForBattery(value)" /></div>
      <div
        :class="value <= 10 ? 'inline-block-vertical-align-middle color-red-vue' : 'inline-block-vertical-align-middle'"
      >
        {{ roundOf(convertBatteryVal(value)) }}%
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BatteryComponent",
    props: {
      value: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        publicUrl: process.env.PUBLIC_URL
      }
    },
    methods: {
      convertBatteryVal: (value) => {
        if (value) {
          if (value > 100) {
            return 100
          }
          if (value < 0) {
            return 0
          }
        }
        return value
      },
      imageForBattery: (value) => {
        if (typeof value !== "undefined") {
          if (value === 0) {
            return "/battery/0.svg"
          }
          if (value <= 10) {
            return "/battery/10.svg"
          }
          if (value <= 25) {
            return "/battery/25.svg"
          }
          if (value <= 50) {
            return "/battery/50.svg"
          }
          if (value <= 75) {
            return "/battery/75.svg"
          }
          return "/battery/100.svg"
        }
        return false
      }
    }
  }
</script>
